module.exports = __webpack_public_path__ + "static/img/minibagswoman.4e14bd2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cover/20210918/minibagswoman.jpg
// module id = zFej
// module chunks = 1